import { Component, FC, PropsWithChildren, ReactNode } from 'react';
import { NavigateFunction, useNavigate } from 'react-router';
import { RouteParamsValidationException } from '../../../shared/fe/routes/RouteParamsValidationException';
import * as Sentry from '@sentry/react';

type Props = PropsWithChildren & { navigate: NavigateFunction };

type State = {
	hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	public state: State = {
		hasError: false,
	};

	public componentDidCatch(error: Error): void {
		if (error instanceof RouteParamsValidationException) {
			Sentry.captureException(error);
			this.props.navigate('/maintenance/404');
			return;
		}

		throw error;
	}

	public render(): ReactNode {
		return this.props.children;
	}
}

const ErrorBoundaryWithRouter: FC<PropsWithChildren> = ({ children }) => {
	const navigate = useNavigate();

	return <ErrorBoundary navigate={navigate}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWithRouter;
